import { BaseApiService } from '@shared/services/BaseApiService';
import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';
import { isID } from '@shared/helpers/uid';

class WorksheetActionServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(campaign_id, params) {
    return this.http
      .post(`/${campaign_id}/actions`, params)
      .then((item) => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }

  updateItem(campaign_id, id, params) {
    return this.http.put(`/${campaign_id}/actions/${id}`, params).then((item) => {
      return WorksheetActionModelSelector.getBackendModel(item).toFrontend();
    });
  }

  removeItem(campaign_id, id) {
    return this.http.delete(`/${campaign_id}/actions/${id}`);
  }

  createOrUpdateItem(worksheet_id, id, params) {
    if (isID(id)) {
      return this.updateItem(worksheet_id, id, params);
    } else {
      return this.createItem(worksheet_id, params);
    }
  }
}

export const WorksheetActionService = new WorksheetActionServiceClass({
  api_version: 2,
  resource: 'informer/campaigns'
});
